import React from "react";
import { createPortal } from "react-dom";
import "./styles.css";
import { vector } from "../../../assets/images";

interface AFLErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  message: string;
  title?: string;
}

const AFLErrorModal: React.FC<AFLErrorModalProps> = ({
  isOpen,
  onClose,
  message,
  title = "OOPS!",
}) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="afl-error-modal-overlay">
      <div className="afl-error-modal-container scale-in">
        <div className="afl-error-modal-content">
          <div className="afl-error-icon-wrapper">
            <img
              src={vector}
              alt="Error"
              className="afl-error-icon"
            />
          </div>

          <h3 className="afl-error-title">{title}</h3>
          <p className="afl-error-modal-message">{message}</p>

          <div className="afl-error-modal-footer">
            <button className="afl-dismiss-btn" onClick={onClose}>
              Dismiss
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AFLErrorModal;
